export default {
  'servicePeriod.title': '就餐时段',
  'servicePeriod.title_link': '就餐时段 <a>（设置你的就餐时段）</a>',
  'servicePeriod.column.title_link': '去设置就餐时段',
  'servicePeriod.column.name': '名称',
  'servicePeriod.column.orders': '订单数',
  'servicePeriod.column.net_sales': '税前营业额',
  'servicePeriod.column.discounts': '折扣',
  'servicePeriod.column.refund_amount': '退款额',
  'servicePeriod.column.gross_sales': '销售额',
  'servicePeriod.column.tax_amount': '税额',
  'servicePeriod.column.total_tips': '小费总计',
};
